import { render } from "./Folder.vue?vue&type=template&id=006682c1"
import script from "./Folder.vue?vue&type=script&lang=ts"
export * from "./Folder.vue?vue&type=script&lang=ts"
script.render = render

export default script